(function () {
  'use strict';
  if (!window.IntersectionObserver) return;

  function anim(el, opts) {
    el.classList.add('bm-anim');
    if (opts && opts.scale) el.classList.add('bm-anim--scale');
    if (opts && opts.delay != null) el.style.setProperty('--anim-delay', opts.delay + 's');
  }

  /* Section headings */
  document.querySelectorAll(
    '.bm-section-header, .bm-overline, ' +
    '.bm-pdp-edu__problems-heading, .bm-pdp-edu__how-heading, .bm-pdp-edu__eng-heading, ' +
    '.bm-pdp-faq__heading, .bm-pdp-upsell__heading, .bm-pdp-reviews__heading'
  ).forEach(function (el) { anim(el); });

  /* Hero — stagger on load */
  document.querySelectorAll(
    '.bm-hero__trust-row, .bm-hero__heading, .bm-hero__body, .bm-hero__checklist, .bm-hero__ctas'
  ).forEach(function (el, i) { anim(el, { delay: 0.1 + i * 0.1 }); });

  /* Shop by need cards */
  document.querySelectorAll('.bm-shop-by-need__card').forEach(function (el, i) {
    anim(el, { scale: true, delay: i * 0.1 });
  });

  /* Trust features */
  document.querySelectorAll('.bm-trust-features__item').forEach(function (el, i) {
    anim(el, { delay: i * 0.1 });
  });

  /* Product cards (bestsellers, upsell, collection grid) */
  document.querySelectorAll('.bm-bestsellers__card, .bm-product-card').forEach(function (el, i) {
    anim(el, { scale: true, delay: (i % 4) * 0.08 });
  });

  /* Review cards */
  document.querySelectorAll('.bm-reviews__card, .bm-pdp-reviews__card').forEach(function (el, i) {
    anim(el, { scale: true, delay: (i % 3) * 0.08 });
  });

  /* Community photos */
  document.querySelectorAll('.bm-community__photo-card').forEach(function (el, i) {
    anim(el, { scale: true, delay: i * 0.06 });
  });

  /* Product feature section */
  document.querySelectorAll('.bm-product-feature__gallery, .bm-product-feature__info').forEach(function (el, i) {
    anim(el, { delay: i * 0.14 });
  });
  document.querySelectorAll('.bm-product-feature__badge-item').forEach(function (el, i) {
    anim(el, { delay: i * 0.08 });
  });

  /* Moisture meters */
  document.querySelectorAll('.bm-moisture-meters__image-col, .bm-moisture-meters__text-col').forEach(function (el, i) {
    anim(el, { scale: i === 0, delay: i * 0.14 });
  });

  /* Wholesale */
  document.querySelectorAll('.bm-wholesale__text-col, .bm-wholesale__image-col').forEach(function (el, i) {
    anim(el, { scale: i === 1, delay: i * 0.14 });
  });

  /* Smart banner */
  document.querySelectorAll('.bm-smart-banner__card').forEach(function (el) {
    anim(el, { scale: true });
  });

  /* Comparison header */
  document.querySelectorAll('.bm-comparison__header').forEach(function (el) { anim(el); });

  /* Collection hero */
  document.querySelectorAll('.bm-col-hero__heading, .bm-col-hero__body').forEach(function (el, i) {
    anim(el, { delay: i * 0.1 });
  });

  /* PDP education steps + feature cards */
  document.querySelectorAll('.bm-pdp-edu__step').forEach(function (el, i) {
    anim(el, { scale: true, delay: (i % 2) * 0.1 });
  });
  document.querySelectorAll('.bm-pdp-edu__feature--card').forEach(function (el, i) {
    anim(el, { scale: true, delay: (i % 3) * 0.07 });
  });

  /* PDP buy box micro-reviews */
  document.querySelectorAll('.bm-pdp__micro-review').forEach(function (el, i) {
    anim(el, { delay: i * 0.1 });
  });

  /* FAQ items */
  document.querySelectorAll('.bm-pdp-faq__item').forEach(function (el, i) {
    anim(el, { delay: i * 0.05 });
  });

  /* FBT cards */
  document.querySelectorAll('.bm-pdp-fbt__card').forEach(function (el, i) {
    anim(el, { scale: true, delay: i * 0.08 });
  });

  /* Observe all animated elements */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });

  document.querySelectorAll('.bm-anim').forEach(function (el) { observer.observe(el); });

  /* Hero fires immediately — already in viewport on load */
  requestAnimationFrame(function () {
    document.querySelectorAll('.bm-hero .bm-anim').forEach(function (el) {
      el.classList.add('is-visible');
    });
  });
}());
